<template>
  <div
    v-if="userEqui == 'pc'"
    class="noShow"
    style="
      width: 100%;
      height: 66px;
      background: white;
      /* position: fixed; */
      z-index: 120;
    "
  >
    <div class="header">
      <div class="title">
        <img :src="logoSrc" alt="" style="margin-right: 10px" />
        <div class="cascaderDiv">
          <el-cascader
            ref="address"
            :options="options"
            placeholder="请选择区县"
            clearable
            v-model="areaCodeTop"
            size="mini"
            :props="props"
            :show-all-levels="false"
            @change="xzqChange"
            :style="{ width: cascaderWidth + 'px' }"/>
        </div>
        {{ title }}
      </div>

      <div class="menu">
        <ul>
          <li
            v-for="item of menuList"
            :key="item.code"
            :class="item.label == currentMenu ? 'active' : ''"
          >
            <a @click="menuHandle(item.label)">{{ item.name }}</a>
          </li>
        </ul>
      </div>
      <!-- 聊天框 -->
      <div>
        <el-badge
          :value="AllMessages == 0 ? '' : AllMessages"
          :max="99"
          class="item"
        >
          <el-button size="small" @click="Online()">消息</el-button>
        </el-badge>
      </div>
      <div class="operation" v-if="!showOpt || !identityObj.identityName">
        <!-- <div class="search">
          <el-input
            style="width: 290px"
            v-model="keyword"
            placeholder="请输入关键词"
          ></el-input>
          <el-button type="primary">
            <img src="../../assets/icon-search.png" />
          </el-button>
        </div> -->
        <div class="login">
          <span @click="userLogin" class="with-icon">
            <img src="../../assets/icon-user.png" />
            登录
          </span>
          <span @click="userRegister">注册</span>
        </div>
      </div>

      <div class="user" v-if="showOpt && identityObj.identityName">
        <el-dropdown @command="handleCommand">
          <div class="photo">
            <!-- <img :src="imgSrc" alt="" /> -->
            <span>{{ identityObj.identityName }}</span>
            <span style="color: #00a0e9" v-if="identityObj.identityTypeDesc"
              >({{ identityObj.identityTypeDesc }})</span
            >，你好
          </div>
          <!-- 因新增按钮退出command改为2 -->
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="0">会员中心</el-dropdown-item>
            <!-- <el-dropdown-item command="1">商家入驻</el-dropdown-item> -->
            <el-dropdown-item command="2">退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button
          v-if="
            this.identityObj.identityTypeCode == 19 ||
            this.identityObj.identityTypeCode == 8 ||
            this.identityObj.identityTypeCode == 23 ||
            this.identityObj.identityTypeCode == 6 ||
            this.identityObj.identityTypeCode == 22
          "
          type="text"
          style="margin-left: 30px"
          icon="el-icon-data-board"
          @click="screenStatistics"
          >智能驾驶舱</el-button
        >
      </div>
    </div>
  </div>
  <div
    v-else
    class="noShow"
    style="
      width: 100%;
      /* height:60px; */
      background: white;
      /* position: fixed; */
      z-index: 120;
    "
  >
    <div class="header-web">
      <!-- 将pc端一行header拆解为两行 -->
      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <div class="title">
          <img :src="logoSrc" alt="" />
          {{ title }}
          <el-cascader
            :options="options"
            placeholder="请选择区县"
            clearable
            v-model="areaCodeTop"
            size="mini"
            :props="props"
            :show-all-levels="false"
            @change="xzqChange"
            style="width: 80px; line-height: 57px"
          ></el-cascader>
        </div>
        <!-- 聊天框 -->
        <div>
          <el-badge
            :value="AllMessages == 0 ? '' : AllMessages"
            :max="99"
            class="item"
          >
            <el-button size="small" @click="Online()">消息</el-button>
          </el-badge>
        </div>
        <div class="operation" v-if="!showOpt || !identityObj.identityName">
          <!-- <div class="search">
          <el-input
            style="width: 290px"
            v-model="keyword"
            placeholder="请输入关键词"
          ></el-input>
          <el-button type="primary">
            <img src="../../assets/icon-search.png" />
          </el-button>
        </div> -->
          <div class="login">
            <span @click="userLogin" class="with-icon">
              <img src="../../assets/icon-user.png" />
              登录
            </span>
            <span @click="userRegister">注册</span>
          </div>
        </div>
        <div class="user" v-if="showOpt && identityObj.identityName">
          <el-dropdown @command="handleCommand">
            <div class="photo">
              <!-- <span>{{ identityObj.identityName }}</span> -->
              <span>我的</span>
              <!-- <span style="color: #00a0e9" v-if="identityObj.identityTypeDesc"
                >({{ identityObj.identityTypeDesc }})</span
              >，你好 -->
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="0">会员中心</el-dropdown-item>
              <!-- <el-dropdown-item command="1">商家入驻</el-dropdown-item> -->
              <el-dropdown-item command="2">退出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div style="display: flex; justify-content: center; height: 30px">
        <div class="menu">
          <ul>
            <li
              v-for="item of menuList"
              :key="item.code"
              :class="item.label == currentMenu ? 'active' : ''"
            >
              <a @click="menuHandle(item.label)">{{ item.name }}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getStore } from "../../js/utils/store";
import { mapGetters, mapMutations } from "vuex";
import { getXzqArr, getUserMenuByIdentity } from "@/api/add";
import { removeEmptyChildren } from "@/js/utils/util";
import { UnreadMessage } from "../../api/websocket";
import { Utils } from "@/assets/js/util.js";
// import {initWebSocket} from '@/util/websocket'

const menuList = [
  {
    code: 1,
    name: "首页",
    label: "homepage",
  },
  {
    code: 2,
    name: "生产服务",
    label: "productionService",
  },
  {
    code: 3,
    name: "资源资产服务",
    label: "resourcesService",
  },
  {
    code: 4,
    name: "财务服务",
    label: "financialService",
  },
  {
    code: 5,
    name: "产销对接",
    label: "supplyOrder",
  },
];

const countyList = [
  {
    code: 1,
    name: "宣汉县",
  },
  {
    code: 2,
    name: "开江县",
  },
  {
    code: 3,
    name: "大竹县",
  },
  {
    code: 4,
    name: "渠县",
  },
  {
    code: 5,
    name: "通川区",
  },
  {
    code: 6,
    name: "达川区",
  },
  {
    code: 7,
    name: "万源市",
  },
];
export default {
  data() {
    return {
      cascaderWidth: 110,
      userEqui: sessionStorage.getItem("equiType"), //设备类型 参数为web或pc
      equiWidth: sessionStorage.getItem("equiWidth"), //设备宽度 参数为用户当前设备的实际宽度（单位：px）
      options: [],
      props: {
        label: "areaName",
        children: "children",
        value: "id",
        checkStrictly: true,
      },
      keyword: "",
      showOpt: getStore({ name: "access_token" }),
      imgSrc: "",
      isReload: true,
      logoSrc: window.pageConfiguration.homeLogo,
      title: "农业社会化服务平台",
      //window.pageConfiguration.title,
      menuList,
      countyList,
      currentMenu: "homepage",
      value: 1,
      areaCodeTop: "",
      MessagesReceived: "",
      websocketUrl: window.globalUrl.WEBSOCKET_URL,
      screenFlag: false,
    };
  },
  watch: {
    $route: {
      handler: function (newV) {
        this.currentMenu = newV.name;
        this.showOpt = getStore({ name: "access_token" });
        if (this.showOpt) {
          // this.initAvatar();
        }
      },
      immediate: true,
    },
    areaCodeTop: {
      handler(newVal, oldVal) {
        this.handleCascaderChange(newVal);
      },
      immediate: true,
    },
    topSelectAreacodeArr: {
      handler(newVal, oldVal) {
        this.areaCodeTop = newVal;
      },
    },
  },
  created() {
    // this.UnMessage();
    this.getRegions();
    this.webSocketInit();
    setTimeout(() => {
      this.areaCodeTop = this.topSelectAreacodeArr;
    }, 100);
  },
  mounted() {
    this.getRegions();
    setTimeout(() => {
      this.areaCodeTop = this.topSelectAreacodeArr;
    }, 100);
    var that = this;
    Utils.$on("demo", function (msg) {
      console.log(msg);
      that.webSocketInit();
    });
  },
  computed: {
    ...mapGetters([
      "identityObj",
      "userInfo",
      "vipLeftTree",
      "topSelectAreacode",
      "topSelectAreacodeArr",
      "AllMessages",
    ]),
  },
  methods: {
    ...mapMutations([
      "setTopSelectAreacode",
      "setTopSelectAreacodeArr",
      "setTopSelectAreaname",
      "SET_MESSAGE",
      "setVipTree",
      "setTopSelectAreaCenterPoint",
    ]),

    // 级联选择器值变化时触发
    async handleCascaderChange(val) {
      if (!val || val.length === 0) {
        // 清空选择时，恢复默认宽度
        this.cascaderWidth = 110;
        return;
      }

      // 轮询配置：检查间隔（ms）、超时时间（ms）
      const pollInterval = 100; // 每100ms检查一次
      const timeout = 5000; // 超时时间5秒，避免无限轮询
      let elapsedTime = 0; // 已消耗时间
      let cascaderNode = null;

      try {
        // 封装轮询逻辑为Promise，直到获取到节点或超时
        cascaderNode = await new Promise((resolve, reject) => {
          const timer = setInterval(() => {
            // 可选链保护：避免ref不存在或方法不存在时报错
            const node = this.$refs.address?.getCheckedNodes?.()[0];
            if (node) {
              clearInterval(timer); // 拿到节点，清除定时器
              resolve(node); // 成功返回节点
            }

            // 累计时间，判断是否超时
            elapsedTime += pollInterval;
            if (elapsedTime >= timeout) {
              clearInterval(timer); // 超时，清除定时器
              reject(new Error("获取级联选择器选中节点超时")); // 抛出超时错误
            }
          }, pollInterval);
        });

        const label = cascaderNode?.label || "";
        if (!label) {
          this.cascaderWidth = 110;
          return;
        }

        const fontSize = 25; // 对应选择器的字体大小（需和样式一致）
        let textWidth = 0;
        for (let i = 0; i < label.length; i++) {
          const char = label.charAt(i);
          // 区分中英文（中文占1个 fontSize，英文占0.5个）
          textWidth += /[\u4e00-\u9fa5]/.test(char) ? fontSize : fontSize * 0.5;
        }

        // 加上内边距和箭头宽度（避免文字溢出）
        const padding = 0; // 左右内边距+箭头图标宽度
        this.cascaderWidth = textWidth + padding;
      } catch (error) {
        // 处理超时或其他异常，恢复默认宽度
        console.error(error);
        this.cascaderWidth = 110;
        return;
      }
    },

    //判断是否能看数据大屏
    judgeScreen() {
      //县、镇级 镇政府  运营公司可以看到
      if (
        this.identityObj.identityTypeCode == 19 ||
        this.identityObj.identityTypeCode == 8 ||
        this.identityObj.identityTypeCode == 23 ||
        this.identityObj.identityTypeCode == 6 ||
        this.identityObj.identityTypeCode == 22
      ) {
        this.screenFlag = true;
      }
    },

    //建立连接
    webSocketInit() {
      // if(this.webSocketObject){
      //   return;
      // }
      this.openid = JSON.parse(localStorage.getItem("access_token"));
      let autoId = this.identityObj.identityId;
      if (!autoId) {
        return;
      }
      const webSocketUrl =
        `${this.websocketUrl}/${autoId}/computer?authorization=` +
        this.openid.content;
      console.log(webSocketUrl);

      this.webSocketObject = new WebSocket(webSocketUrl);
      this.webSocketObject.onopen = this.webSocketOnOpen;
      this.webSocketObject.onmessage = this.webSocketOnMessage;
      this.webSocketObject.onclose = this.webSocketOnClose;
      this.webSocketObject.onerror = this.webSocketOnError;
    },
    //连接打开
    webSocketOnOpen(e) {
      console.log("与服务端连接打开->", e);
      if (this.webSocketObject.readyState == this.webSocketObject.CONNECTING) {
        console.log("连接正在打开");
      }
      if (this.webSocketObject.readyState == this.webSocketObject.OPEN) {
        console.log("连接已打开");
        this.UnMessage();
      }
      // header页面传入choose页面的方法
      //开启心跳
      // this.start();
    },
    //调用chat页面的方法
    updateChat(e) {
      Utils.$emit("updateChat", e);
    },
    //调用chat页面的方法
    updatelist(e) {
      Utils.$emit("updatelist", e);
    },
    //调用chat页面的方法
    upisChange(e) {
      Utils.$emit("upisChange", e);
    },
    //调用dbspDetails页面的方法
    dbspDetails(e) {
      Utils.$emit("dbspDetails", e);
    },
    //调用监听
    // 触发"isAgree"事件，并将 WebSocket 消息对象继续向下传递
    isAgree(e) {
      Utils.$emit("isAgree", e);
    },

    // 消息监听
    webSocketOnMessage(e) {
      console.log("来自服务端的消息->", JSON.parse(e.data).type);
      if (JSON.parse(e.data).type == "agreeProcess") {
        this.dbspDetails(e);
      } else if (JSON.parse(e.data).type == "isAgree") {
        this.isAgree(e);
      } else {
        let msgData = JSON.parse(e.data);

        // JSON.parse()
        // console.log();
        // console.log("msgData->111111",JSON.parse(msgData.content).receiverId );
        // debugger
        if (
          this.identityObj.identityId != JSON.parse(msgData.content).receiverId
        ) {
          console.log("来自服务端的消息->return");

          return false;
        }
        if (JSON.parse(e.data).type == "new message") {
          //调用chat页面里面接受到的新消息
          // Utils.$on('MessagesReceived',data=>{
          //   this.MessagesReceived=data
          // })
          // console.log(this.MessagesReceived)
          // this.updateChat(this.MessagesReceived);
          this.updateChat(e);
          //消息未读总数
          this.UnMessage();
        } else if (JSON.parse(e.data).type == "isAgree") {
          console.log("isAgree1111");
          this.updatelist(e);
          //消息未读总数
          this.UnMessage();
        } else if (JSON.parse(e.data).type == "isChange") {
          console.log("isChange");
          this.upisChange(e);
          //消息未读总数
          this.UnMessage();
        }
      }
    },
    // 监听报错
    webSocketOnError(e) {
      console.log("与服务端连接异常->", e);
      //重连
      this.reconnect();
    },
    checkChatExist(conversationId) {
      for (let index = 0; index < this.dataList.length; index++) {
        const element = this.dataList[index];
        if (conversationId == element.conversationId) {
          return true;
        }
      }
      return false;
    },
    // 监听连接关闭
    webSocketOnClose(e) {
      console.log("与服务端连接关闭->", e);
      if (e.code === 1000) {
        console.log("WebSocket连接正常关闭");
      } else {
        if (e.code === 1001) {
          console.log("WebSocket连接由于终端离开而关闭");
        } else if (e.code === 1002) {
          console.log(
            e.code +
              " " +
              e.reason +
              " " +
              e.wasClean +
              "WebSocket连接由于协议错误而关闭"
          );
        } else if (e.code === 1003) {
          console.log("WebSocket连接由于接收到的数据类型错误而关闭");
        } else if (e.code === 1005) {
          console.log("WebSocket连接由于无法获取状态码而关闭");
        } else if (e.code === 1006) {
          console.log("WebSocket连接由于连接被重置而关闭");
          console.log(e);
        } else if (e.code === 1011) {
          console.log("WebSocket连接由于服务器端发生异常而关闭");
        } else if (e.code === 1015) {
          console.log("WebSocket连接由于TLS握手失败而关闭");
        }
        //重连
        this.reconnect();
      }
    },
    // 重新连接
    reconnect() {
      if (this.lockReconnect) {
        return;
      }

      this.lockReconnect = true;

      // 取消之前的重连请求
      clearTimeout(this.timeoutnum);

      // 设置新的重连逻辑
      this.timeoutnum = setTimeout(() => {
        try {
          this.webSocketInit(); // 尝试重新连接
        } catch (error) {
          console.error("重连过程中出现错误:", error); // 错误处理
        } finally {
          this.lockReconnect = false; // 确保锁定状态被释放
        }
      }, 5000);
    },

    // // // 重置心跳
    // reset() {
    //   var that = this;
    //   //清除时间
    //   clearTimeout(that.timeoutObj);
    //   clearTimeout(that.serverTimeoutObj);
    //   //重启心跳
    //   that.start();
    // },

    // // 开启心跳
    // start() {
    //   var self = this;
    //   self.timeoutObj && clearTimeout(self.timeoutObj);
    //   self.serverTimeoutObj && clearTimeout(self.serverTimeoutObj);
    //   self.timeoutObj = setTimeout(function () {
    //     //这里发送一个心跳，后端收到后，返回一个心跳消息，
    //     if (self.webSocketObject.readyState == 1) {
    //       let Prompt = {
    //         heart: "Hello",
    //       };
    //       let HeartbeatDetection = JSON.stringify(Prompt);
    //       self.webSocketObject.send(HeartbeatDetection);
    //     } else {
    //       //否则重连
    //       self.reconnect();
    //     }
    //     self.serverTimeoutObj = setTimeout(function () {
    //       //超时关闭
    //       self.webSocketObject.close();
    //     }, self.timeout);
    //   }, self.timeout);
    // },
    //查询总的未读消息
    async UnMessage() {
      let params = {
        receiverId: this.identityObj.identityId,
      };
      let res = await UnreadMessage(params);
      let AllMessages = res.data;
      this.SET_MESSAGE(AllMessages);
    },

    xzqChange(val) {
      console.log("地区选择改变", val);
      this.handleCascaderChange(val);
      this.setTopSelectAreacode(val[val.length - 1]);
      this.setTopSelectAreacodeArr(val);
      let node = this.$refs.address.getCheckedNodes()[0];
      console.log("查看node", node);
      if (node) {
        // console.log(node.label, '查看label')
        this.setTopSelectAreaname(node.label);
        console.log("查看node.data.centerPoint", node.data.centerPoint);
        this.setTopSelectAreaCenterPoint(node.data.centerPoint);
      } else {
        this.setTopSelectAreaname("");
        this.setTopSelectAreaCenterPoint("");
      }
    },
    //在线沟通
    async Online() {
      this.$router.push("/home/Chat");
    },
    async getRegions() {
      let res = await getXzqArr({
        level: 3,
      });
      if (res.code == 0) {
        this.options = removeEmptyChildren(res.data, "children");
      }
    },
    async screenStatistics() {
      // this.$router.push({ name: "screenStatistics" });
      const access_token = getStore({ name: "access_token" });
      const obj = getStore({
        name: "identityObj",
      });

      // 处理areaFullName，获取最后一个区域名称
      const areaName = obj.areaFullName
        ? obj.areaFullName.split("/").pop()
        : "";
      // 处理areaCode，获取前6位
      const areaCode = obj.areaCode ? obj.areaCode.substring(0, 6) : "";

      // 动态获取域名
      const baseUrl =
        window.globalUrl?.BASE_API?.replace("/api/", "") ||
        "https://test.xctfw.com";

      // 根据areaCode判断path
      const path = areaCode === "511703" ? "equipmentpark" : "starpark";

      window.open(
        `${baseUrl}/daping/${path}?token=${access_token}&areacode=${areaCode}&areaname=${areaName}`,
        "_self"
      );
      // window.open(window.location.origin + `#/screenStatistics`,'_blank', 'noopener');
    },
    menuHandle(name) {
      // console.log(name, '跳转菜单名字');
      this.$router.push({
        name: name,
      });

      this.currentMenu = name;
    },
    userLogin() {
      if (this.userInfo.identityList) {
        if (this.userInfo.identityList.length > 0) {
          this.$router.push({ name: "chooseRole" });
        } else {
          this.$router.push({ name: "login" });
        }
      } else {
        // 用户登录
        this.$router.push({ name: "login" });
      }
    },
    userRegister() {
      // 用户注册
      this.$router.push({ name: "register" });
    },
    transMenu(tree, parentName = "") {
      for (let i = 0; i < tree.length; i++) {
        const node = tree[i];
        const nodePath = node.path; // 获取当前节点的 path 字段
        // 修改-如果父级path为空那么不加/
        // const fullName = parentName + (node.path ? "/" + node.path : ""); // 拼接全称
        // const fullName = parentName + "/" + node.path; // 拼接全称
        const fullName =
          nodePath && nodePath.includes("/")
            ? "/memberCenter/" + node.path
            : parentName + "/" + node.path;
        if (node.children) {
          this.transMenu(node.children, fullName); // 递归调用函数遍历子节点
        }
        node.allPath = fullName; // 赋值全称给节点
      }
      return tree;
      // console.log(tree, '查看tree')
    },
    transMenu2(tree, parentName = "") {
      for (let i = 0; i < tree.length; i++) {
        const node = tree[i];
        const nodePath = node.path; // 获取当前节点的 path 字段
        // 修改-如果父级path为空那么不加/
        // const fullName = parentName + (node.path ? "/" + node.path : ""); // 拼接全称
        // const fullName = parentName + "/" + node.path; // 拼接全称
        const fullName =
          nodePath && nodePath.includes("/")
            ? "/businessCenter/" + node.path
            : parentName + "/" + node.path;
        if (node.children) {
          this.transMenu(node.children, fullName); // 递归调用函数遍历子节点
        }
        node.allPath = fullName; // 赋值全称给节点
      }
      return tree;
    },
    async getOthersInfo() {
      try {
        let res = await getUserMenuByIdentity();

        // console.log(res, "查看菜单");

        if (res.code == 0 && res.data.menuList.length > 0) {
          res.data.menuList.forEach((item) => {
            if (item.path === "memberCenter") {
              let arr = this.transMenu([item][1].children, "/memberCenter");

              if (arr.length > 0) {
                this.setVipTree(arr);
                this.$router.$avueRouter.formatRoutes(arr, true);
                if (arr[0].children.length == 0) {
                  this.$router.push({
                    path: arr[0].allPath,
                  });
                } else {
                  if (arr[0].children.length > 0) {
                    this.$router.push({
                      path: arr[0].children[0].allPath,
                    });
                  }
                }
              }
            } else {
              console.log("这里执行了嘛");
              //是商品管理时
              let arr = this.transMenu2([item][0].children, "/businessCenter");

              if (arr.length > 0) {
                this.setVipTree(arr);
                this.$router.$avueRouter.formatRoutes(arr, true);
                if (arr[0].children.length == 0) {
                  this.$router.push({
                    path: arr[0].allPath,
                  });
                } else {
                  if (arr[0].children.length > 0) {
                    this.$router.push({
                      path: arr[0].children[0].allPath,
                    });
                  }
                }
              }
            }
          });
        }
      } catch (error) {
        console.log("错误", error);
      }
    },
    handleCommand(command) {
      // console.log(command, '查看返回的什么')
      // 下拉菜单点击
      switch (command) {
        // 会员中心
        case "0":
          let arr = this.vipLeftTree;
          // console.log("arr左边菜单", arr);
          if (!this.userInfo.identityList) {
            this.$router.push({ name: "login" });
          } else {
            // console.log("进来了")
            if (this.identityObj.identityName && arr.length == 0) {
              this.getOthersInfo();
            }
            if (arr.length > 0) {
              if (arr[0].children.length == 0) {
                // console.log("arr13123213", arr[0].allPath);
                this.$router.push({
                  path: arr[0].allPath,
                });
              } else {
                if (arr[0].children.length > 0) {
                  this.$router.push({
                    path: arr[0].children[0].allPath,
                  });
                }
              }
            }
          }
          break;
        //商家入驻
        // case '1':
        //   // console.log('商家入驻')
        //   this.$router.push({ name: "supplierRegistration" });
        //   break;
        // 退出
        case "2":
          this.$confirm("是否退出系统, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            // data.access_token

            if (this.webSocketObject) {
              this.SET_MESSAGE(0);
              this.webSocketObject.close();
            }
            this.$store.dispatch("LogOut").then(() => {
              // location.reload();
              // this.$router.go(0);
              this.showOpt = "";
              this.$router.push({ path: "/home/homepage" });
            });
            localStorage.clear();
          });
          break;
      }

      // if (command == 0) {
      //   // 会员中心
      //   let arr = this.vipLeftTree;
      //   console.log("arr左边菜单", arr);
      //   if (!this.userInfo.identityList) {
      //     this.$router.push({ name: "login" });
      //   } else {
      //     console.log("进来了")
      //     if (this.identityObj.identityName && arr.length == 0) {
      //       this.getOthersInfo();
      //     }
      //     if (arr.length > 0) {
      //       if (arr[0].children.length == 0) {
      //         // console.log("arr13123213", arr[0].allPath);
      //         this.$router.push({
      //           path: arr[0].allPath,
      //         });
      //       } else {
      //         if (arr[0].children.length > 0) {
      //           this.$router.push({
      //             path: arr[0].children[0].allPath,
      //           });
      //         }
      //       }
      //     }
      //   }
      // } else {
      //   // this.$router.push({name: 'homepage'})
      //   this.$confirm("是否退出系统, 是否继续?", "提示", {
      //     confirmButtonText: "确定",
      //     cancelButtonText: "取消",
      //     type: "warning",
      //   }).then(() => {
      //     localStorage.clear();
      //     if (this.webSocketObject) {
      //       this.SET_MESSAGE(0);
      //       this.webSocketObject.close();
      //     }
      //     this.$store.dispatch("LogOut").then(() => {
      //       // location.reload();
      //       // this.$router.go(0);
      //       this.showOpt = "";
      //       this.$router.push({ path: "/home/homepage" });
      //     });
      //   });
      // }
    },
  },
};
</script>

<style lang="less" scoped>
.cascaderDiv {
  margin-top: 7px;
  padding-bottom: 5px;
  border-bottom: 1px solid #000;
}
.header {
  width: 1600px !important;
  height: 66px;
  margin: auto;
  display: flex;
  box-sizing: border-box;
  justify-content: space-between;
  align-items: center;
  // position: fixed;
  background: #fff;

  .title {
    height: 57px;
    align-items: center;
    display: flex;
    // font-weight: bold;
    font-size: 25px;
    color: #333;

    // 针对el-cascader的容器
    ::v-deep .el-cascader {
      display: flex;
      align-items: center; /* 让级联选择器整体垂直居中 */
      height: 32px; /* mini尺寸高度 */
    }

    // 级联选择器的输入框外层
    ::v-deep .el-cascader .el-input__wrapper {
      display: flex;
      align-items: center;
      height: 100%; /* 继承父级高度 */
      padding: 0 10px 0 25px; /* 左侧留箭头位置，右侧留内边距 */
    }

    // 输入框内容垂直居中
    ::v-deep .el-cascader .el-input__inner {
      height: 100%;
      line-height: normal; /* 重置行高，避免继承.title的57px */
      display: flex;
      align-items: center;
      text-align: right; /* 保持你要的右对齐 */
      border: none !important; /* 确保边框隐藏 */
      color: #333;
    }


    /deep/.el-input--suffix {
      font-size: 24px !important;

      ::placeholder {
        font-size: 22px !important;
      }
    }

    img {
      height: 43px;
      margin-top: 4px;
    }

    .el-select {
      width: 90px;
    }
  }

  .operation {
    display: flex;
    // justify-content: flex-start;
    align-items: center;

    .login {
      font-size: 14px;
      margin-left: 37px;
      color: #8d8d8d;
      display: flex;
      align-items: center;

      span {
        cursor: pointer;
        margin: 0px 6px;
      }

      .with-icon {
        display: flex;
        align-items: center;

        img {
          margin-right: 5px;
        }
      }
    }

    .search {
      border: 1px solid #ccc;
      border-radius: 42px;

      .el-button {
        width: 55px;
        height: 36px;
        padding: 0 6px;
        background: transparent;
        border-color: transparent;
        color: #333;
        // background-color: #00a0e9;
        line-height: 35px;

        img {
          vertical-align: middle;
          margin-right: 5px;
          margin-bottom: 3px;
        }
      }
    }
  }

  .user {
    .photo {
      // width: 50px;
      border-radius: 25px;
      display: inline-block;
      line-height: 60px;

      img {
        background-color: #e3e3e3;
        height: 50px;
        width: 50px;
        border-radius: 25px;
        vertical-align: middle;
        margin-right: 10px;
        // width: 100%;
        // height: 100%;
      }
    }
  }

  .menu {
    ul {
      display: flex;

      li {
        list-style: none;
        margin: 0px 25px;
        color: #333;
        font-weight: bold;

        a:hover {
          color: #0668b3;
          cursor: pointer;
        }

        &.active {
          color: #0668b3;
          position: relative;

          &::before {
            position: absolute;
            content: "";
            width: 36px;
            height: 3px;
            bottom: -8px;
            left: calc(50% - 18px);
            background: #0668b3;
          }
        }
      }
    }
  }

  .ChatFrame {
    border: none;
  }
}

.ChatFrame {
  border: none;
}

.header-web {
  // width: 100% !important;
  // height: 33px;
  margin: auto;
  // display: flex;
  box-sizing: border-box;
  // justify-content: space-between;
  // align-items: center;
  background: #fff;
  padding: 0 10px;

  .title {
    height: 57px;
    line-height: 57px;
    display: flex;
    font-weight: bold;
    font-size: 12px;
    color: #333;

    /deep/.el-input--suffix {
      font-size: 8px !important;

      ::placeholder {
        font-size: 6px !important;
      }
    }

    //web端适配区县选择器下拉框
    /deep/ .el-cascader__dropdown {
      margin: 5px 0px 5px 170px;
    }

    /deep/ .el-cascader-menu {
      width: 40px;
    }

    img {
      height: 12px;
      margin-top: 20px;
    }

    .el-select {
      width: 90px;
    }
  }

  .operation {
    display: flex;
    // justify-content: flex-start;
    align-items: center;

    .login {
      font-size: 14px;
      margin-left: 37px;
      color: #8d8d8d;
      display: flex;
      align-items: center;

      span {
        cursor: pointer;
        margin: 0px 6px;
      }

      .with-icon {
        display: flex;
        align-items: center;

        img {
          margin-right: 5px;
        }
      }
    }

    .search {
      border: 1px solid #ccc;
      border-radius: 42px;

      .el-button {
        width: 55px;
        height: 36px;
        padding: 0 6px;
        background: transparent;
        border-color: transparent;
        color: #333;
        // background-color: #00a0e9;
        line-height: 35px;

        img {
          vertical-align: middle;
          margin-right: 5px;
          margin-bottom: 3px;
        }
      }
    }
  }

  .user {
    .photo {
      // width: 50px;
      border-radius: 25px;
      display: inline-block;
      line-height: 60px;

      img {
        background-color: #e3e3e3;
        height: 50px;
        width: 50px;
        border-radius: 25px;
        vertical-align: middle;
        margin-right: 10px;
        // width: 100%;
        // height: 100%;
      }
    }
  }

  .menu {
    ul {
      display: flex;

      li {
        list-style: none;
        margin: 0px 8px;
        color: #333;
        font-weight: bold;

        a:hover {
          color: #0668b3;
          cursor: pointer;
        }

        &.active {
          color: #0668b3;
          position: relative;

          &::before {
            position: absolute;
            content: "";
            width: 36px;
            height: 3px;
            bottom: -8px;
            left: calc(50% - 18px);
            background: #0668b3;
          }
        }
      }
    }
  }

  .ChatFrame {
    border: none;
  }
}

/* 调整级联选择器下拉箭头到左侧 */
::v-deep .el-cascader {
  width: 100%;
}

::v-deep .el-cascader .el-input {
  position: relative;
}

::v-deep .el-cascader .el-input__wrapper {
  position: relative;
}

::v-deep .el-cascader .el-input__suffix {
  position: absolute;
  left: auto;
  right: 0;
  transform: translateX(0);
  width: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .el-cascader .el-input__inner {
  padding-left: 0;
  padding-right: 0px;
  font-size: 25px;
  text-align: right;
  // color: rgb(112, 227, 112) !important;
}

::v-deep .el-cascader .el-input__icon {
  display: none;
  // margin: 0;
  // font-size: 16px;
  // transition: none;
  // font-weight: bold;
  // color: #000 !important;
}

/* 确保下拉菜单位置正确 */
::v-deep .el-cascader__dropdown {
  left: 0 !important;
}

/* 确保节点内的箭头也正确显示 */
::v-deep .el-cascader-menu {
  .el-cascader-node {
    position: relative;
    padding-right: 20px;
    padding-left: 10px;
  }

  .el-cascader-node__postfix {
    position: absolute;
    right: 5px;
    left: auto;
    margin: 0;
    transform: rotate(0deg);
  }
}
</style>

<style lang="less">
.search {
  .el-input__inner {
    height: 35px;
    border: transparent;
    border-radius: 32px;

    &::-webkit-input-placeholder {
      /* WebKit browsers 适配谷歌 */
      color: #999;
    }

    &:-moz-placeholder {
      /* Mozilla Firefox 4 to 18 适配火狐 */
      color: #999;
    }

    &::-moz-placeholder {
      /* Mozilla Firefox 19+ 适配火狐 */
      color: #999;
    }

    &:-ms-input-placeholder {
      /* Internet Explorer 10+  适配ie*/
      color: #999;
    }
  }
}

.title {
  .el-input__inner {
    border: 0;
  }
}
</style>
